
/**
 * @typedef {Object} VideoParams
 * @param {boolean} autoplay
 * @param {boolean} mute
 * @param {boolean} loop
 * @param {boolean} hideControls
 * @param {string} url
 */

export default class VideoBase {
    constructor(theme, element) {
        this.theme = theme;
        this.element = element;
    }

    /**
     * Get autoplay with overrides
     *
     * @param {boolean} autoplay User autoplay preference
     * @return {boolean}
     */
    getAutoplay = (autoplay) => {
        // Autoplay if Save-Data is not set
        if ("connection" in navigator) {
            if (navigator.connection.saveData) {
                return false;
            }
        }
        // Autoplay if reduced motion is not set
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return false;
        }
        return autoplay;
    }

    /**
     * Load the video JS library (if needed)
     * @returns {Promise<void>}
     */
    _load = async () => {};

    /**
     * Prepare (and play if autoplay is on) the video
     *
     * @param {VideoParams} params Video playback parameters
     */
    init = (params) => {}

    /**
     * Play the video
     */
    play = () => {}

    /**
     * Pause the video
     */
    pause = () => {}
}
